import { trigger, transition, style, animate, AnimationTriggerMetadata } from '@angular/animations';

export const fade: AnimationTriggerMetadata = trigger('fade', [transition(':enter', [style({ opacity: 0 }), animate('500ms ease', style({ opacity: 1 }))]), transition(':leave', [animate('500ms ease', style({ opacity: 0 }))])]);
